module.exports = __webpack_public_path__ + "resources/img/img_skyhigh_security_m.d75d4d4cb7ce55007201b0dc21c0a8f4.png";